
import { defineComponent } from 'vue'

import { CProduct } from '@/retail/contexts/product'

export default defineComponent({
  name: 'VProduct',
  components: {
    CProduct,
  },
  props: {
    sku: {
      type: String,
      default: undefined,
    },
  },
})
